export default __webpack_public_path__ + "static/media/bidImgSrcTwo.819d9454.jpeg";